import React from 'react';

import Container from '@src/components/Shared/Container';
import NextImage from '@src/components/Shared/NextImage';
import RenderBodyCopy from '@src/components/Shared/RenderBodyCopy';
import RenderButtons from '@src/components/Shared/RenderButtons';

import { AthleteTechPropTypes, AthleteTechTypes } from './AthleteTech.types';

const AthleteTech: React.FC<AthleteTechPropTypes> = ({ id, items }) => {
  return (
    <Container id={id}>
      <div className='mx-auto grid max-w-[105.1rem] grid-cols-[100%] gap-[1rem] md:grid-cols-[50%_50%] lg:grid-cols-[42.5%_25.8%_25.8%] lg:gap-[3rem]'>
        {items?.map((athleteTech: AthleteTechTypes, index: any) => {
          return (
            <div
              className={` ${
                index === 0 ? 'col-span-1 row-span-2 w-full' : 'col-span-1 w-full'
              } flex flex-none shrink-0 flex-col overflow-hidden rounded-[0.8rem] border border-[#E6E6E6] pb-[2rem]`}
              key={athleteTech?.sys?.id}
            >
              <NextImage
                src={athleteTech?.mediaPrimary?.url}
                alt={athleteTech?.mediaPrimary?.description}
                className={`${
                  index === 0 ? 'h-[68rem]' : 'min-h-[17.5rem]'
                } relative mb-[3.2rem] w-full overflow-hidden [&>img]:object-top`}
              />

              <div className='flex h-full flex-col px-[1.9rem] [&>ul]:grid [&>ul]:grid-cols-2'>
                <p className='text-body-copy--dark mb-[1.8rem] text-[2.2rem] leading-none font-normal'>
                  {athleteTech.title}
                </p>
                <RenderBodyCopy
                  bodyCopy={athleteTech?.bodyCopy?.json?.content}
                  className='mt-[1rem] mb-[3rem]! text-[1.5rem]'
                />
                <RenderButtons
                  className={`${index === 0 ? 'mt-[0rem]!' : 'mt-auto!'} [&_a]:justify-start!`}
                  items={athleteTech?.buttonCollection?.items}
                />
              </div>
            </div>
          );
        })}
      </div>
    </Container>
  );
};

export default AthleteTech;
